import React, { useCallback, useContext } from "react";
import { UI } from "@wwimmo/ui";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react";
import { RootStoreContext } from "src/stores/RootStore";
import { useTranslation } from "react-i18next";
import styles from "./AssignInvoiceProgress.module.css";
import { ASSIGN_INVOICE_STATE } from "src/stores/krediflow/AssignInvoiceStore";

interface AssignInvoiceProgressProps {
    currentAssignInvoiceState: ASSIGN_INVOICE_STATE;
}

export const AssignInvoiceProgressBase = (props: AssignInvoiceProgressProps) => {
    const { t } = useTranslation();
    const { assignInvoiceStore } = useContext(RootStoreContext);

    const { currentAssignInvoiceState } = props;

    const onClickFinishAssignInvoice = useCallback(() => {
        assignInvoiceStore.setIsModalDisplayed(false);
        assignInvoiceStore.resetAssignInvoiceModal();
    }, [assignInvoiceStore]);

    let icon;
    let text;

    switch (currentAssignInvoiceState) {
        case ASSIGN_INVOICE_STATE.ASSIGNING:
            icon = <UI.RotatingSpinner noLogo size={50} className="loading-items-spinner" />;
            text = t("screens.kredi_flow.action.assign_invoice.in_progress").toString();
            break;
        case ASSIGN_INVOICE_STATE.FINISHED:
            icon = <UI.Icon icon={UI.SVGIcon.Check} size={50} color={"black"} />;
            text = t("screens.kredi_flow.action.assign_invoice.success").toString();
            break;
    }

    return (
        <UI.Row className={"mt-2 d-flex"}>
            <UI.Col
                xs={12}
                className={`d-flex align-items-center justify-content-center ${styles.AssignInvoiceProgressContainer}`}
            >
                <div className="d-flex align-items-center flex-column">
                    <div>{icon}</div>
                    <div className="d-flex mt-2">
                        <span className={`${styles.AssignInvoiceProgressText} text-center`}>{text}</span>
                    </div>
                </div>
            </UI.Col>
            <UI.Col xs={12} className="mt-4">
                <UI.Button
                    className={`mt-2 ${styles.FinishButton}`}
                    label={t("labels.finished").toString()}
                    disabled={currentAssignInvoiceState === ASSIGN_INVOICE_STATE.ASSIGNING ? true : false}
                    onClick={onClickFinishAssignInvoice}
                ></UI.Button>
            </UI.Col>
        </UI.Row>
    );
};

export const AssignInvoiceProgress = Sentry.withProfiler(observer(AssignInvoiceProgressBase));
